var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { mode: "out-in", name: "fade" } },
    [
      !_vm.isLoadingEvents && _vm.events.length > 0
        ? _c("section", { key: "events", staticClass: "events" }, [
            _c(
              "ul",
              _vm._l(_vm.events, function(event) {
                return _c(
                  "li",
                  { key: event.id, staticClass: "event" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "event__link",
                        class: {
                          "event__link--urgent": Boolean(
                            _vm.eventsUrgencyMap[event.id]
                          )
                        },
                        attrs: { to: _vm.makeEventRoute(event) },
                        nativeOn: {
                          click: function($event) {
                            _vm.onEventClick(event)
                          }
                        }
                      },
                      [
                        _c(
                          "script",
                          { attrs: { type: "application/ld+json" } },
                          [
                            _vm._v(
                              '\n                    {\n                        "@context": "http://schema.org",\n                        "@type": "Event",\n                        "name": "' +
                                _vm._s(event.name) +
                                '",\n                        "location": {\n                            "@type": "Place",\n                            "name": "' +
                                _vm._s(event.venueName) +
                                '",\n                            "address": {\n                                "@type": "PostalAddress",\n                                "addressLocality": "' +
                                _vm._s(event.venueCity) +
                                '",\n                                "addressRegion": "' +
                                _vm._s(event.venueRegionCode) +
                                '"\n                            }\n                        },\n                        "startDate": "' +
                                _vm._s(event.localDate) +
                                '",\n                        "url": "' +
                                _vm._s(event.schemaOrgUrl) +
                                '"\n                    }\n                    '
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isShowThumbnails
                          ? _c(
                              "div",
                              {
                                staticClass: "event__thumbnail",
                                style: {
                                  backgroundImage:
                                    "url(" + _vm.thumbnailImage(event) + ")"
                                }
                              },
                              [
                                event.is_sold_out
                                  ? _c("Tag", {
                                      staticClass: "event__sold-out--desktop",
                                      attrs: {
                                        context: "error",
                                        text: "Sold Out"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "fx-hidden--small event__listing-date"
                              },
                              [
                                _c("fx-event-listing-date", {
                                  attrs: {
                                    event: {
                                      local_date: event.localDate,
                                      is_date_tbd: event.isDateTbd,
                                      is_time_tbd: event.isTimeTbd
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c("div", { staticClass: "event__info" }, [
                          _c("div", [
                            _c("div", { staticClass: "event__name" }, [
                              _vm._v(_vm._s(event.name))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "event__content" }, [
                              _c("div", { staticClass: "left" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "event__datetime",
                                    class: {
                                      "fx-hidden--medium": !_vm.isShowThumbnails,
                                      "fx-hidden--large": !_vm.isShowThumbnails,
                                      "fx-hidden--full": !_vm.isShowThumbnails
                                    }
                                  },
                                  [
                                    event.isDateTbd
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "event__date" },
                                            [_vm._v("Date TBD")]
                                          )
                                        ]
                                      : event.isTimeTbd
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "event__date" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("date")(
                                                    event.localDate,
                                                    "ddd, MMM D, YYYY"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(", Time TBD")
                                        ]
                                      : event.localDateLabel
                                      ? [
                                          _c(
                                            "span",
                                            { staticClass: "event__date" },
                                            [
                                              _vm._v(
                                                _vm._s(event.localDateLabel)
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            " at " +
                                              _vm._s(
                                                _vm._f("date")(
                                                  event.localDate,
                                                  "h:mma"
                                                )
                                              )
                                          )
                                        ]
                                      : [
                                          _c(
                                            "span",
                                            { staticClass: "event__date" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("date")(
                                                    event.localDate,
                                                    "ddd, MMM D, YYYY"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            " at " +
                                              _vm._s(
                                                _vm._f("date")(
                                                  event.localDate,
                                                  "h:mma"
                                                )
                                              )
                                          )
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "span",
                                    { staticClass: "event__location" },
                                    [
                                      event.venueRegionCode
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(event.venueName) +
                                                ", " +
                                                _vm._s(event.venueCity) +
                                                ", " +
                                                _vm._s(event.venueRegionCode)
                                            )
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              _vm._s(event.venueName) +
                                                ", " +
                                                _vm._s(event.venueCity)
                                            )
                                          ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "event__price" },
                                    [
                                      !event.is_sold_out
                                        ? _c(
                                            "i",
                                            { staticClass: "event__price-dot" },
                                            [
                                              _vm._v(
                                                "\n                                                ·\n                                            "
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      event.is_sold_out
                                        ? _c("Tag", {
                                            staticClass:
                                              "event__sold-out--mobile",
                                            attrs: {
                                              context: "error",
                                              text: "Sold Out"
                                            }
                                          })
                                        : !_vm.$config.isIntegrated
                                        ? [
                                            _vm.isLoyaltyPricing &&
                                            event.pointsPriceMin
                                              ? _c("span", [
                                                  _vm._v(
                                                    " from " +
                                                      _vm._s(
                                                        _vm.formatPoints(
                                                          event.pointsPriceMin,
                                                          event.pointsCurrency
                                                        )
                                                      )
                                                  )
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    " from " +
                                                      _vm._s(
                                                        _vm._f("numeral")(
                                                          event.moneyPriceMin,
                                                          "$0,0"
                                                        )
                                                      )
                                                  )
                                                ])
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "right" }, [
                                _c("span", {
                                  staticClass:
                                    "fx-hidden--medium fx-hidden--large fx-hidden--full icon-chevron-lg-right"
                                })
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          event.isPartnerExclusive
                            ? _c(
                                "div",
                                [
                                  _c("Tag", {
                                    attrs: {
                                      text: "Cardholder Exclusive",
                                      context: "exclusive"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.eventsUrgencyMap[event.id]
                          ? _c("span", { staticClass: "event__urgency" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("event-list.urgency", {
                                    count: _vm.eventsUrgencyMap[event.id]
                                  })
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "button fx-hidden--small fx-hidden--medium fx-hidden--large event__get-tickets",
                            class: {
                              "event__get-tickets--urgent": Boolean(
                                _vm.eventsUrgencyMap[event.id]
                              )
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                event.is_sold_out
                                  ? "View Details"
                                  : "Get Tickets"
                              )
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              })
            ),
            _vm._v(" "),
            _vm.isShowLoadMoreButton
              ? _c(
                  "button",
                  {
                    staticClass: "button load-more",
                    attrs: { type: "button" },
                    on: { click: _vm.loadMoreEvents }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.isLoadingMoreEvents
                          ? _vm.loadingMoreCopy
                          : _vm.loadMoreCopy
                      )
                    )
                  ]
                )
              : _vm._e()
          ])
        : _vm.isLoadingEvents
        ? _c(
            "section",
            { key: "loading", staticClass: "loading" },
            [_c("fx-spinner")],
            1
          )
        : _vm._t("events-not-found", [
            _c("NoResults", { attrs: { "show-redirect": _vm.isShowRedirect } })
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }